<template>
  <BannerBlock titleClass="">
    <template v-slot:title>{{ $t("banner.guideTips") }}</template>
    <template v-slot:message>
      {{ $t("banner.guideTipsDesc") }}
    </template>
    <template v-slot:actions>
      <button class="btn btn-success" @click="$router.replace({ name: 'Tutorials' })">{{ $t("banner.watchTuts") }}</button>
    </template>
    <template v-slot:default>
      <!-- <img class="ml-auto" src="@/core/assets/Dashboard/Banner/Guide/tips.svg" /> -->
      <!-- <div class="bg ml-auto col-sm-4 d-none d-sm-unset"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Guide/tips.svg')" />
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../../BannerBlock";
export default {
  name: "GuideTip",
  components: {
    BannerBlock
  },
  data() {
    return {
      // dayLeft: 2
    };
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
// .bg {
//   background-image: url(~@/core/assets/Dashboard/Banner/Guide/tips.svg);
//   width: 288px;
// }
</style>
